import React from 'react'
import { FormattedMessage } from 'react-intl'

// Providers
import { useWizardProvider } from '../../../../Components/shared/WizardContext'

// Components
import {
  Text,
  If,
  Unless,
  BotHeadSpin,
  FormField,
  Button,
} from '../../../../Components'
import { IconPencil } from '../../../../Components/shared/Icon'

// Context
import { useSignUpProvider } from '../SignUpContext'

// styles
import styles from './Name.module.scss'

const Name = () => {
  const { loading, formState, handleOnChange } = useSignUpProvider()
  const { email, firstName, lastName } = formState
  const { goBack } = useWizardProvider()

  return (
    <>
      <Unless condition={loading}>
        <div className={styles.nameStepContainer}>
          <Text
            weight='light'
            size='xl'
            variant='neutralCool'
            variantCount='900'
            className={styles.headline}
          >
            <FormattedMessage
              id='NewBuyerSignUp.nameStep.salutation'
              defaultMessage='Last step!'
            />
          </Text>
          <Text variant='neutralCool' variantCount='700' size='s'>
            <FormattedMessage
              id='NewBuyerSignUp.nameStep.helper'
              defaultMessage="Create an account so you can view customer insights for each home you're interested in."
            />
          </Text>
          <If condition={email}>
            <div className={styles.email}>
              <Text
                element='span'
                variant='neutralCool'
                variantCount='700'
                size='s'
              >
                <FormattedMessage
                  id='NewBuyerSignUp.nameStep.account.for'
                  defaultMessage='Account for'
                />
              </Text>{' '}
              <Button iconEnd={IconPencil} onClick={goBack}>
                {email}
              </Button>
            </div>
          </If>
          <div className={styles.forms}>
            <FormField.FirstName value={firstName} onChange={handleOnChange} />
            <FormField.LastName value={lastName} onChange={handleOnChange} />
          </div>
        </div>
      </Unless>
      <If condition={loading}>
        <BotHeadSpin panelSpacing />
      </If>
    </>
  )
}

export default Name
